import i18n from 'i18next';

// English uses the British format so dates stay day-first, as in Finnish.
const DATE_LOCALES: { [language: string]: string } = {
  en: 'en-GB',
  fi: 'fi-FI',
};

const getDateLocale = (language: string | undefined = i18n.language): string =>
  DATE_LOCALES[language ?? ''] ?? DATE_LOCALES.fi;

export { getDateLocale };
